/* @flow */

import React from 'react';
import {useSelector} from 'react-redux';

import Box from '@material-ui/core/Box';

import BlogComponent from 'components/blogs';

import SupplierInvoiceListComponent from './invoices';

export default function SupplierDashboardComponent() {
  const languageId = useSelector(state => state.locale.languageId);

  return (
    <React.Fragment>
      <SupplierInvoiceListComponent />
          
      <Box mt={5}>
        <BlogComponent key={`blogs-${languageId}`} />
      </Box>
    </React.Fragment>
  );
}
